import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { Button } from "@mui/material";
import { useSelector } from "react-redux";

export default function DeleteDialog({
  deletingContent,
  setDeletingContent,
  onDelete,
}) {
  const user = useSelector((state) => state.user);
  return (
    <Dialog
      open={Boolean(deletingContent.table)}
      onClose={() => {
        setDeletingContent({ table: "", row: 0 });
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Confirm Delete</DialogTitle>
      <DialogContent>
        {/* <DialogContentText id="alert-dialog-description">
            This will delete the row in table {deletingContent.table} with id:{" "}
            {deletingContent.row}
          </DialogContentText> */}
      </DialogContent>
      <DialogActions>
        <Button
          className="cancel-button"
          onClick={() => {
            setDeletingContent({ table: "", row: 0 });
          }}
        >
          Cancel
        </Button>
        <Button
          disabled={/^Trial_User$/i.test(user.role) ? true : false}
          className="blue-button"
          onClick={onDelete}
          autoFocus
          variant="contained"
          color="error"
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
